import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../hooks/useAuth'
import { useSettings } from '../../../hooks/useSettings'
import { ReleaseContainer } from '../ReleaseContainer/ReleaseContainer'
import { GetUserReleases } from '../releases'
import './ReleaseModal.scss'

export function ReleaseModal() {
  const [lastSeenRelease, saveLastSeenRelease, lastSeenReleaseLoading] = useSettings('lastSeenRelease')
  const [width, setWidth] = useState<number>(window.innerWidth)
  const [visible, setVisible] = useState<boolean>(true)
  const { t, i18n } = useTranslation('common')
  const { user } = useAuth()

  const lang = i18n.language as 'en' | 'de' | 'fr' | 'it'
  const isMobile = width <= 768

  function handleWindowSizeChange() {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const releaseToShow = useMemo(() => {
    if (!lastSeenReleaseLoading) {
      const releases = GetUserReleases(user)
      const lastRelease = releases.at(0)
      if (lastRelease && lastRelease.name !== lastSeenRelease.toString()) {
        return lastRelease
      }
    }
    return undefined
  }, [lastSeenRelease, lastSeenReleaseLoading, user])

  const handleDontShowAgainClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation()
    if (releaseToShow) {
      saveLastSeenRelease(releaseToShow.name)
    }
    setVisible(false)
  }

  return (
    !isMobile &&
    !!releaseToShow &&
    visible && (
      <div className="release-modal-background">
        <div className="release-modal">
          <div className="closeButton">
            <button title={t('CLOSE').toString()} onClick={() => setVisible(false)}>
              <i className="icon-close" />
            </button>
          </div>
          <div className="release-modal-header">
            {releaseToShow.modalHeader?.image && <img src={releaseToShow.modalHeader.image} />}
            {releaseToShow.modalHeader?.title && <span>{releaseToShow.modalHeader.title[lang]}</span>}
            {releaseToShow.modalHeader?.icon && <i className={releaseToShow.modalHeader.icon} />}
          </div>
          <div className="release-modal-body">
            <div className="release-modal-info">
              <ReleaseContainer release={releaseToShow} />
            </div>
            <button className="dont-show-release" onClick={handleDontShowAgainClick}>
              {t('DONT_SHOW_AGAIN').toUpperCase()}
            </button>
          </div>
        </div>
      </div>
    )
  )
}
